function debounce(func, wait) {
  let timeout: NodeJS.Timeout
  return (...args) => {
    if (timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(() => func(...args), wait)
  }
}

export default debounce
